module.exports = require("./fa-AF");